import { InfiniteData } from '@tanstack/react-query'
import { useMemo } from 'react'
import { usePaginatedBoards } from '@opallabs/api'
import { OpalApiResponseDocument } from '@opallabs/api/v3'
import { BoardData } from '../types'

type BoardsResponseDocument = OpalApiResponseDocument<'ReadBoardsV3', 200>

const selectPaginatedBoardData = (
  infiniteData?: InfiniteData<BoardsResponseDocument>
): Array<BoardData> => {
  if (!infiniteData) return []

  const allBoards: Array<BoardData> = []
  for (const page of infiniteData.pages) {
    for (const board of page.data) {
      allBoards.push({
        id: board.id,
        title: board.attributes.title,
        defaultStoryId: board.relationships.default_story?.data?.id,
      })
    }
  }

  return allBoards
}

export const useBoardData = (workspaceUuid: string) => {
  const { fetchingComplete, isFetching, isFetchedAfterMount, boards } =
    usePaginatedBoards({
      workspaceId: workspaceUuid,
      fields: {
        board: 'title,default_story',
      },
      include: ['default_story' as const],
      select: selectPaginatedBoardData,
    })

  return useMemo(
    () => ({
      isSuccess: fetchingComplete,
      isLoading: !fetchingComplete,
      isFetching,
      isFetchedAfterMount,
      data: boards ?? [],
    }),
    [fetchingComplete, isFetching, isFetchedAfterMount, boards]
  )
}
